import { useState } from "react";
import { GuestCheckoutModal } from "~/features/cart/B2CCart/components/GuestCheckoutDialog/GuestCheckoutDialog";
import { userRolesAreAuthenticated, userRolesAreRegistered } from "~/domains/user/utils/roles";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { CART_STEP_3 } from "~/utils/url/staticUrls";
import { updateSalesPartner } from "~/domains/salesPartner/api/updateSalesPartner";
import type { GuestCheckoutFormData } from "~/features/cart/B2CCart/components/GuestCheckoutDialog/components/GuestCheckoutFormModal";
import { submitGuestCheckoutForm } from "~/features/cart/B2CCart/components/GuestCheckoutDialog/api/guestCheckoutSubmitForm";
import { useSession } from "~/app/config/useSession";
import { occCartUserPathFor } from "~/app/api/occ/occUserPath";
import { activeCartResourceId } from "~/domains/cart/utils/cartResourceIdentity";

export const useGuestCheckoutDialog = () => {
  const [open, setOpen] = useState(false);
  const session = useSession();
  const roles = session?.user.roles ?? [];
  const authenticated = userRolesAreAuthenticated(roles);
  const registered = userRolesAreRegistered(roles);
  const userPath = occCartUserPathFor(authenticated);
  const cartId = activeCartResourceId(session?.activeCart, authenticated);

  const onSubmit = async (formData: GuestCheckoutFormData) => {
    if (!cartId) {
      setOpen(false);
      return;
    }
    const response = await submitGuestCheckoutForm(cartId, formData);
    if (response.ok) {
      const context = response.headers.get("X-Schaeffler-Guest-Checkout-Context");
      if (context) {
        redirectToUrl(`${CART_STEP_3}#guestCheckoutContext=${encodeURIComponent(context)}`);
      }
    } else {
      console.log(response.status);
      console.log(await response.text());
    }
    setOpen(false);
  };

  const dialog = <GuestCheckoutModal open={open} onClose={() => setOpen(false)} onSubmit={onSubmit} />;

  const handleCheckoutClick = async (subsidiaryId: string) => {
    if (!cartId) {
      return;
    }
    await updateSalesPartner(subsidiaryId, cartId, userPath);
    if (registered) {
      redirectToUrl(CART_STEP_3);
    } else {
      setOpen(true);
    }
  };

  return [handleCheckoutClick, dialog] as const;
};
